import React from 'react';
import store from "../store";
import {openToast} from "../store/global/toastSlice";

export default class Toast {

    static show(message) {
        store.dispatch(openToast({
            message: message,
            variant: 'default',
        }));
    }

    static success(message = null) {
        store.dispatch(openToast({
            message: message || 'Listo',
            variant: 'success',
        }));
    }

    static warning(message) {
        store.dispatch(openToast({
            message: message,
            variant: 'warning',
        }));
    }

    static error(message) {
        store.dispatch(openToast({
            message: message,
            variant: 'error',
        }));
    }

    static info(message) {
        store.dispatch(openToast({
            message: message,
            variant: 'info',
        }));
    }
}